import { render, staticRenderFns } from "./cartridge-add.vue?vue&type=template&id=ba91c1be&"
import script from "./cartridge-add.vue?vue&type=script&lang=js&"
export * from "./cartridge-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba91c1be')) {
      api.createRecord('ba91c1be', component.options)
    } else {
      api.reload('ba91c1be', component.options)
    }
    module.hot.accept("./cartridge-add.vue?vue&type=template&id=ba91c1be&", function () {
      api.rerender('ba91c1be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/cartridge-list/cartridge-add.vue"
export default component.exports